<template>
    <div>
        <RadioGroup :slug="props.slug" :description="props.description" :isSmallLabel="props.isSmallLabel" :filterValues="props.filterValues" :label="props.title" :showNumResults="true" @radioChange="onFilterChange" />
    </div>
</template>

<script setup lang="ts">
import { FilterValue } from 'Vue/interfaces/LockDesigner';
import { ref, defineProps, defineEmits, onMounted } from 'vue';
import RadioGroup from './RadioGroup.vue';
const componentName = 'Radio';

const props = defineProps({
    slug: { type: String, required: true },
    title: { type: String, required: true },
    displayExpanded: { type: Boolean, default: false },
    isSingleSelect: { type: Boolean, default: false },
    hasFilters: { type: Boolean, default: false },
    filterValues: { type: Array as () => FilterValue[], required: true },
    isSmallLabel: { type: Boolean, default: false },
    description: { type: String, default: '' }
});

const selectedValue = ref<any>(null);

const emit = defineEmits(['filterChange', 'infoButtonClick']);

const onFilterChange = async(filterValues: FilterValue[]) => {
    await emit('filterChange', { slug: props.slug, filterValues });
};

const onInfoButtonClick = async() => {
    await emit('infoButtonClick');
};
</script>
